import * as R from 'remeda'

import { diffNineNumbers, type NineSegmentCounts, nineSegments } from '~/utils'

import {
  calcNineSegmentIndicatorCounts,
  nineSegmentIndicators,
  type NineSegmentsData,
} from './nineSegments'

export type NineSegmentsDataInput = {
  nineSegmentCounts: NineSegmentCounts
  total: number
  // The denominators used for non-diff ratios. From useNineSegmentsTotalData's
  // counts; basic-output passes the same counts it just computed.
  totalDataCounts: NineSegmentsData['counts']
}

export const buildNineSegmentsData = (
  input: NineSegmentsDataInput,
): NineSegmentsData => {
  const counts = {
    total: input.total,
    ...input.nineSegmentCounts,
    ...calcNineSegmentIndicatorCounts(input.nineSegmentCounts),
  }
  const ratios = R.mapToObj(
    [
      'total',
      ...nineSegments,
      ...nineSegmentIndicators.filter(
        (indicator) => !indicator.endsWith('Diff'),
      ),
    ] as const,
    (indicator) => [
      indicator,
      counts[indicator] / input.totalDataCounts[indicator],
    ],
  )

  return {
    counts,
    ratios: {
      ...ratios,
      totalDiff: ratios.totalPositive - ratios.totalNegative,
      currentUserDiff: ratios.currentUserPositive - ratios.currentUserNegative,
      recognizedDiff: diffNineNumbers(ratios, 7, 8),
      estrangedDiff: diffNineNumbers(ratios, 5, 6),
      generalDiff: diffNineNumbers(ratios, 3, 4),
      loyalDiff: diffNineNumbers(ratios, 1, 2),
      recognizedPositiveGeneralPositiveDiff: diffNineNumbers(ratios, 3, 7),
      recognizedNegativeGeneralPositiveDiff: diffNineNumbers(ratios, 3, 8),
      estrangedPositiveGeneralPositiveDiff: diffNineNumbers(ratios, 3, 5),
      estrangedNegativeGeneralPositiveDiff: diffNineNumbers(ratios, 3, 6),
      generalPositiveLoyalPositiveDiff: diffNineNumbers(ratios, 1, 3),
      generalNegativeLoyalPositiveDiff: diffNineNumbers(ratios, 1, 4),
      recognizedNegativeLoyalPositiveDiff: diffNineNumbers(ratios, 1, 8),
      estrangedNegativeLoyalPositiveDiff: diffNineNumbers(ratios, 1, 6),
    },
  }
}
